import { FC, ReactNode } from 'react';
import { DocOchDocxFilResponse } from '../../types/media';
import { ContentResponse } from '../../types/shared';

interface IDocOchDocxFil {
  contentResponse: ContentResponse;
}

const DocOchDocxFil: FC<IDocOchDocxFil> = ({ contentResponse }): ReactNode => {
  const contentResponseDoc = contentResponse.content as DocOchDocxFilResponse;

  return <a href={contentResponseDoc.relativeSourceUrl} download>{contentResponse.name}</a>;
};

export default DocOchDocxFil;
